module.exports = __webpack_public_path__ + "125e50470d0c8fb1b63472fb8de1ed21.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg77.jpeg
// module id = 91
// module chunks = 0